module.exports = __webpack_public_path__ + "fonts/icomoon.fbe14665.ttf";